module.exports = __webpack_public_path__ + "img/evidences.ea3d3396.png";